import { PcsEntity } from '@app/pcs/models';
import { EntityType, PropertyNameMapper } from '@app/shared/forms/property-mapper';
import { trainIdMapper } from '@dossier/models';
import { DossierPropertyMap } from '@dossier/models/dossier';

export enum DossierAclActionMap {
  AddTerritory = 'AddTerritory',
  AddUserVariant = 'AddUserVariant',
  AddUserVariantWithPaps = 'AddUserVariantWithPaps',
  AddProductionOnlyApplicantAgency = 'AddProductionOnlyApplicant',
  AddReadOnlyImAgency = 'AddReadOnlyIM',
  AddServiceAgency = 'AddServiceAgency',
  AddProductionAgency = 'AddProductionAgency',
  AddLink = 'AddLink',
  AddComment = 'AddComment',
  MakeObservation = 'MakeObservation',
  AddRfcAgency = 'AddRfcAgency',
  ViewApplicantTimetable = 'ViewApplicantTimetable',
  ViewImTimetable = 'ViewImTimetable',
  ViewCossTimetable = 'ViewCossTimetable',
  ViewFeasibilityStudyTimetable = 'ViewFeasibilityStudyTimetable',
  ViewControl = 'ViewControl',
  ViewCompositeRelations = 'ViewCompositeRelations',
  ViewTrainComposition = 'ViewTrainComposition',
  ViewConnections = 'ViewConnections',
  ViewPathVariants = 'ViewPathVariants',
  ViewPapRequestDetails = 'ViewPapRequestDetails',
  EditUserVariantCalendar = 'EditUserVariantCalendar',
  CopyDossier = 'CopyDossier',
  SubmitPathAlterationModification = 'SubmitPathAlterationModificationConference',
  OfferInProgressNotification = 'OfferInProgressNotification',
  EditParticipatingCompanies = 'EditParticipatingCompanies',
  EditDossierAgencies = 'EditDossierAgencies'
}

const baseDossierAclMapper = {
  trainType: DossierPropertyMap.TrainType,
  ttp: DossierPropertyMap.Ttp,
  dossierTypeId: DossierPropertyMap.DossierTypeId
};

export const dossierCatalogDataMapper = new PropertyNameMapper({
  papId: 'papId'
}, {entityName: PcsEntity.CatalogData, entityType: EntityType.Object});

export const dossierAclMapper = new PropertyNameMapper({
  ...baseDossierAclMapper,
  trainId: trainIdMapper
});

export const catalogDossierAclMapper = new PropertyNameMapper({
  ...baseDossierAclMapper
});

const baseDossierValdrMapper = {
  title: DossierPropertyMap.Title,
  trainType: DossierPropertyMap.TrainType,
  ttp: DossierPropertyMap.Ttp,
  dossierTypeId: DossierPropertyMap.DossierTypeId
};

export const dossierValdrMapper = new PropertyNameMapper({
  ...baseDossierValdrMapper,
  trainId: trainIdMapper
}, {entityName: PcsEntity.Dossier, entityType: EntityType.Object});

export const catalogDossierValdrMapper = new PropertyNameMapper({
  ...baseDossierValdrMapper,
  catalogData: dossierCatalogDataMapper
}, {entityName: PcsEntity.Dossier});
